import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";
import fileDownload from "js-file-download";

import {
  IonActionSheet,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";

import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import useTituloPagina from "../../hooks/tituloPagina";
import { Card, IconButton, Table, Typography } from "@mui/joy";
import {
  Column,
  Container,
  Row,
} from "../../components/basicsComponents/MaterialGridComponents";
import { LinkOutlined, OpenInNew } from "@mui/icons-material";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";
import "./Imagenes.css";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function ImagenesPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  const [estudioSel, setEstudioSel] = useState(-1);
  const [listadoEstudiosFiltro, setListadoEstudiosFiltro] = useState([]);
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
  });
  const [abrirModal, setAbrirModal] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };
  const history = useHistory();
  useTituloPagina();

  const abrirCerrarModal = () => setAbrirModal(!abrirModal);

  const formatearFechaEstudio = (fechaApi, nombreArchivo) => {
    const fechaDesdeApi = dayjs(fechaApi);
    if (fechaApi && fechaDesdeApi.isValid()) {
      return fechaDesdeApi.format("DD/MM/YYYY");
    }

    let nombre = nombreArchivo || "";
    nombre = nombre.replace(".pdf", "").replace(".PDF", "");

    const fechaDesdeNombre = dayjs(
      new Date(
        Number(nombre.substr(-8, 4)),
        Number(nombre.substr(-4, 2)) - 1,
        Number(nombre.substr(-2, 2))
      )
    );

    if (
      fechaDesdeNombre.isValid() &&
      (fechaDesdeNombre.isBefore(dayjs()) || dayjs().isSame(fechaDesdeNombre, "day"))
    ) {
      return fechaDesdeNombre.format("DD/MM/YYYY");
    }

    return "No disponible";
  };

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = null;
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      const response = await axios.get(
        `${url}EstudiosImagenes/Paciente?paciente=${paciente.codigo}`,
        config
      );
      if (response.data.length !== 0) {
        estudios = response.data;
      } else {
        estudios = [];
      }

      estudios = estudios.map((estudio, i) => {
        let nombre = estudio.nombre || estudio.estudioNom || "";
        const fecha = formatearFechaEstudio(estudio.fecha, nombre);

        return {
          ...estudio,
          codigo: i,
          fechaOriginal: estudio.fecha || null,
          fecha,
          text: nombre,
        };
      });
      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      setListadoEstudiosFiltro(estudios);
    } catch ({ response }) {
      mostrarNotificacion(true, "Error: " + response, "rojo");
    }
  };

  const FiltrarEstudios = (value) => {
    setCargando(true);
    if (value !== -1) {
      let listado = [];

      listadoEstudios.map((estudio) => {
        if (parseInt(value) === estudio.estudioCod) {
          listado.push(estudio);
        }
      });
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listado);
    } else {
      setEstudioSel(value);
      setListadoEstudiosFiltrados(listadoEstudios);
    }
    setCargando(false);
  };

  const BuscarEstudio = async (estudio) => {
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${usuario.token}` },
    };
    try {
      console.log({ estudio });
      const response = await axios.get(
        `${url}EstudiosImagenes/TraerToken?documentoPaciente=${usuario.documentoNro}&numero=${estudio.numero}&equipo=${estudio.equipo}`,
        config
      );

      if (response.data.length > 0) {
        window.open(response.data, "_blank");
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado",
        "rojo"
      );
    }

    return null;
  };

  const VisualizarPdf = (estudio) => {
    setCargando(true);
    if (estudio) {
      BuscarEstudio(estudio);
    } else {
      mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
    }
    setCargando(false);
  };

  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerEstudiosPaciente(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        setTituloPagina(localStorage.getItem("nombreClinica"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const redirecFromLink = (link) => {
    window.open(link, "_blank");
  };

  const renderTurnosLista = () => {
    return (
      <tbody>
        {listadoEstudiosFiltrados.map((fila) => {
          return (
            <tr>
              {/* <Row xs={12} container> */}
              <td>
                <Typography level="title-sm">{fila.estudioNom}</Typography>
              </td>
              <td>
                <Typography level="title-sm">{fila.fecha}</Typography>
              </td>
              <td>
                <IconButton onClick={() => BuscarEstudio(fila)}>
                  <LinkOutlined />
                </IconButton>
              </td>
              {/* </Row> */}
            </tr>
          );
        })}
      </tbody>
    );
  };
  const renderTurnosListaa = (seePreviusVersion) => {
    return (
      <IonList lines="none">
        <IonGrid className="table">
          <IonItem className="fila cabecera amarillo-sol">
            <IonCol className="celda cabecera">
              <IonCol className="celda cabecera">
                <p>Nombre de estudio</p>
              </IonCol>
              <p>Fecha estudio</p>
            </IonCol>
            <IonCol className="celda cabecera">
              <p>Estudio</p>
            </IonCol>
          </IonItem>
          <IonGrid className="">
            {listadoEstudiosFiltrados.map((fila) => (
              <Card style={{ marginBottom: "7.5px", padding: "0px 14px" }}>
                <Row
                  className=""
                  style={{ textAlign: "start" }}
                  alignItems="center"
                  container
                >
                  <Column
                    style={{ textAlign: "start" }}
                    xs={6}
                    md={8}
                    lg={10}
                    container
                  >
                    <Row alignItems="center" container>
                      <Column xs={12} md={6}>
                        <Typography
                          level="title-lg"
                          sx={{ color: "#80c423", fontWeight: "bold" }}
                        >
                          {fila.estudioNom}
                        </Typography>
                      </Column>
                      <Column xs={8} md={3}>
                        <Typography level="title-lg">
                          {fila.fecha}
                        </Typography>
                      </Column>
                      <Column xs={4} md={3}>
                        <IconButton onClick={() => BuscarEstudio(fila)}>
                          <OpenInNew />
                        </IconButton>
                      </Column>
                    </Row>
                  </Column>
                </Row>
              </Card>
            ))}
          </IonGrid>
        </IonGrid>
      </IonList>
    );
  };

  return (
    <>
      <>
        {true ? (
          <Container
            direction={"column"}
            container
            alignContent={"space-between"}
          >
            <table className="tabla" style={{ marginLeft: "10%" }}>
              <thead
                className="fila cabecera amarillo-sol"
                style={{ height: "50px" }}
              >
                <tr>
                  <td className="celda cabecera" style={{ width: "200px" }}>
                    <Typography level="title-lg" style={{ fontSize: "1.3rem" }}>
                      Nombre de estudio
                    </Typography>
                  </td>
                  <td className="celda cabecera" style={{ width: "150px" }}>
                    <Typography level="title-lg" style={{ fontSize: "1.3rem" }}>
                      Fecha estudio
                    </Typography>
                  </td>
                  <td className="celda cabecera" style={{ width: "100px" }}>
                    <Typography level="title-lg" style={{ fontSize: "1.3rem" }}>
                      Estudio
                    </Typography>
                  </td>
                </tr>
              </thead>
              {renderTurnosLista()}
            </table>
          </Container>
        ) : (
          renderTurnosListaa()
        )}

        <CustomToast
          openToast={toast.open}
          onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
          message={toast.mensaje}
          colorNotificacion={toast.tipo}
        />
      </>
      {cargando && <LoadingBackdrop visualizar={cargando} />}
    </>
  );
}
